import { ReactComponent as EndorsementIconSVG } from '@/assets/icons/New-Endorse.svg';
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export const EndorsementIcon = ({ bgColor = '#DADCFF', width='24px', height='24px', ...props }) => {
	const { color } = props;
    
	return (
		<SvgIcon
			{...props}
			sx={{
				backgroundColor: bgColor, 
				width: width,
				height: height,
				borderRadius: 2,
				'& path': { fill: color },
			}}
		>
			<EndorsementIconSVG />
		</SvgIcon>
	);
};
